<template>
  <gg-card>
    <gg-card-header>
      Ticket Details
      <v-chip v-if="ticket.ticketstatustitle == 'In Progress'"
        class="ma-2"
        label
        color="green"
        text-color="white"
      >
        {{ ticket.ticketstatustitle }}
      </v-chip>
      <v-chip v-else-if="ticket.ticketstatustitle == 'Closed'"
        class="ma-2"
        label
        color="red"
        text-color="white"
      >
        {{ ticket.ticketstatustitle }}
      </v-chip>
      <v-chip v-else
        class="ma-2"
        label
      >
        {{ ticket.ticketstatustitle }}
      </v-chip>
      <v-icon v-if="validated" size="20" color="primary" class="mb-2 ml-1">mdi-check-circle</v-icon>
    </gg-card-header>
    <gg-card-text>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle><strong>Subject</strong></v-list-item-subtitle>
            <v-list-item-title>
              {{ ticket.subject }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-subtitle><strong>Ticket ID</strong></v-list-item-subtitle>
            <v-list-item-title>
              {{ ticket.ticketmaskid }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-subtitle><strong>Department</strong></v-list-item-subtitle>
            <v-list-item-title>
              {{ ticket.departmenttitle }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-subtitle><strong>Related Service</strong></v-list-item-subtitle>
            <v-list-item-title>
              {{ ticket.related_service_text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </gg-card-text>
  </gg-card>
</template>

<script>
export default {
  name: 'TicketDetails',
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    validated: {
      required: true,
      type: Boolean
    },
  },
  computed: {
    title () {
      return `Ticket: ${this.ticketid}`
    },
  }
}
</script>
